import { memo } from "react";
import { centsToPrettyDollars } from "@skillscratch/shared-util";
import { Color } from "@skillscratch/shared-constants";
import treasureSvg from "@/assets/chest-closed-no-margin.svg";
import type { Reward } from "@skillscratch/shared-types";
import type { GameColorScheme } from "@skillscratch/shared-types";
import shieldicon from '@/assets/cardshieldicon.svg';
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import arrowLottie from "@/assets/lottie/arrow.lottie?url";

export const RewardsBar = memo(function RewardsBar({
    colorScheme,
    rewards,
  }: {
    colorScheme: GameColorScheme;
    rewards: Reward[];
  }) {
    return (
      <div
        style={{
          containerType: "inline-size",
          width: "100%",
          fontSize: "5cqw",
  
          display: "grid",
          placeItems: "center",
        }}
      >
        {/* <div
          style={{
            lineHeight: "1.2",
  
            paddingTop: "0.3em",
            paddingLeft: "0.5em",
            paddingRight: "0.5em",
            borderTopLeftRadius: "0.5em",
            borderTopRightRadius: "0.5em",
            background: colorScheme.controlColor,
            color: colorScheme.onControlColor,
          }}
        >
          Win up to
        </div> */}
        <RewardsDisplay rewards={rewards} colorScheme={colorScheme} />
      </div>
    );
  });


function RewardsDisplay({ rewards, colorScheme }: { rewards: Reward[], colorScheme: GameColorScheme }) {
    return (
      <div className="flex-col rounded-lg text-[4.5vw] p-[0.4em_0.4em]"
        style={{
          background: colorScheme.controlColor,
          color: colorScheme.onControlColor,
        }}
      >
        <div className='flex justify-between items-center pb-1 mx-2 border-b-[0.5px] border-gray-50 border-opacity-50 text-sm font-semibold'>
          <span className='flex items-center gap-1'>
            Win up to
            <span className='h-3 w-3 items-center justify-center rotate-90'>
              <DotLottieReact
                src={arrowLottie}
                autoplay
                loop
                style={{
                  objectFit: "contain",
                  transform: "translateY(px)"
                }}
              />
            </span>
          </span>
          <span className='flex items-center gap-1 opacity-50'>
            <img src={shieldicon} className='h-3' alt='secure'/>
            Secure Prizes
          </span>
        </div>
        <div className='flex mt-1'>
          {rewards.map((reward, index) => (
            <div
              key={reward.treasures}
              className="relative flex flex-col items-center justify-center px-2"
            >
              {index !== rewards.length - 1 && (
                <div
                  className="absolute right-0 h-3/5 w-px"
                  style={{
                    background: "rgba(255, 255, 255, 0.3)",
                  }}
                />
              )}
    
              <div className="text-110">
                {centsToPrettyDollars(reward.cents, "round")}
              </div>
              <div
                className="text-sm leading-none mb-1"
                style={{ color: Color.darkerGold }}
              >
                {reward.treasures}
                <img
                  src={treasureSvg}
                  alt="Treasure"
                  className="inline-block align-bottom w-4 h-5 ml-1"
                  style={{
                    width: "0.8em",
                    height: "1em",
                    marginLeft: "0.2em"
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };